import { Logger } from '@core/logging/logger.ts'
import { DebugController } from '../debug/debug-controller.ts'
import { camelToSnakeCase } from '@core/utils/case-convert.ts'

export class LegacyContextProxyFactory {
    public constructor(
        private readonly debugController: DebugController | undefined,
        private readonly logger: Logger,
    ) {}

    public get<T extends {}>(name: string, value: T = {} as T): T {
        return new Proxy(value, {
            get: (target, prop, _receiver) => {
                if (prop in target) {
                    return target[prop as keyof T]
                } else if (camelToSnakeCase(String(prop)) in target) {
                    return target[camelToSnakeCase(String(prop)) as keyof T]
                } else if (['toJSON', 'children'].includes(String(prop))) {
                    /**
                     * - toJSON: Handles passing context to JSON.stringify()
                     * - children: Handles passing context through react processing
                     */
                    return undefined
                }

                this.logger.warn(`Unknown key: context.${name}.${String(prop)}`)
                this.debugController?._debugUnknownContextKey(`context.${name}.${String(prop)}`)

                return undefined
            },
        })
    }
}
